import React from "react";
import { withRouter } from "react-router-dom";
import Editserviceform from "./components/Editserviceform";
function Editservices() {
  return <Editserviceform></Editserviceform>;
}
export default withRouter(Editservices);
